/**
 * Announcement Bar Component
 * 
 * Creates an animated announcement bar that cycles through announcements
 * with slide-in from right and slide-out to left animations.
 */
class AnnouncementBar extends HTMLElement {
  constructor () {
    super();
    this.announcements = this.querySelectorAll( '.announcement-item' );
    this.currentIndex = 0;
    this.totalAnnouncements = this.announcements.length;
    this.speed = parseInt( this.getAttribute( 'data-speed' ) ) * 1000 || 5000;

    // Only start rotation if there are multiple announcements
    if ( this.totalAnnouncements > 1 ) {
      this.startRotation();
    }
  }

  connectedCallback () {
    // Reset the initial state when connected
    if ( this.announcements.length > 0 ) {
      this.announcements[0].classList.add( 'active', 'enter-from-right' );

      // Remove the enter class after animation
      setTimeout( () => {
        if ( this.isConnected ) {
          this.announcements[0].classList.remove( 'enter-from-right' );
        }
      }, 300 );
    }
  }

  startRotation () {
    this.rotationInterval = setInterval( () => {
      this.rotateAnnouncement();
    }, this.speed );
  }

  rotateAnnouncement () {
    // Current announcement exits to left
    this.announcements[this.currentIndex].classList.remove( 'active' );
    this.announcements[this.currentIndex].classList.add( 'exit-to-left' );

    // Calculate next index
    const nextIndex = ( this.currentIndex + 1 ) % this.totalAnnouncements;

    // Set next announcement to enter from right
    setTimeout( () => {
      if ( !this.isConnected ) return; // Check if still in DOM

      // Remove exit class from current and hide it
      this.announcements[this.currentIndex].classList.remove( 'exit-to-left' );
      this.announcements[this.currentIndex].classList.add( 'hidden' );

      // Show next announcement with enter animation
      this.announcements[nextIndex].classList.remove( 'hidden' );
      this.announcements[nextIndex].classList.add( 'active', 'enter-from-right' );

      // Update current index
      this.currentIndex = nextIndex;

      // Remove the enter class after animation
      setTimeout( () => {
        if ( this.isConnected ) {
          this.announcements[this.currentIndex].classList.remove( 'enter-from-right' );
        }
      }, 300 );
    }, 300 ); // Match the animation duration
  }

  disconnectedCallback () {
    if ( this.rotationInterval ) {
      clearInterval( this.rotationInterval );
    }
  }
}

customElements.define( 'announcement-bar', AnnouncementBar );
